import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";

export default function NotFound() {
    return (
        <div
            data-testid="not-found-page"
            className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background px-6 text-center"
        >
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute -left-16 top-16 h-72 w-72 rounded-full bg-brand/10 blur-3xl" />
                <div className="absolute bottom-10 right-10 h-72 w-72 rounded-full bg-accentbrand/20 blur-3xl" />
            </div>

            <div className="relative z-10">
                <p className="text-sm font-semibold uppercase tracking-widest text-brand">
                    404 — Not Found
                </p>
                <h1 className="mt-3 text-5xl font-extrabold tracking-tight text-foreground sm:text-6xl">
                    We can&apos;t find that page.
                </h1>
                <p className="mx-auto mt-4 max-w-md text-base text-muted-foreground">
                    The link may be broken, or the page may have been removed.
                    Let&apos;s get you back to shopping.
                </p>

                <Button
                    asChild
                    size="lg"
                    className="mt-8 bg-brand text-white hover:bg-brand-600 shadow-brand"
                    data-testid="notfound-home"
                >
                    <Link to={ROUTES.home}>
                        <HomeIcon className="mr-2 h-4 w-4" />
                        Go home
                    </Link>
                </Button>
            </div>
        </div>
    );
}
